import Modal from "bootstrap/js/src/modal";
import "./jquery.inview.min";
import "./main";
import "./navigation";
import "select2/dist/css/select2.css";
import "../less/ui-components/bootstrap/modal.scss";
import "./modals/components/pass-cid-to-forms"

import setContactModalHandlers from "./modals/setContactModalHandlers";
import "../less/ui-components/bootstrap/modal-progress";
// import "../../../../assets2/components/site-elements/cookies/cookies";

(function () {
  let arr = [];
  $('button[data-bs-toggle="modal"]').each(function () {
    arr.push($(this).data("bs-target"));
  });
  [...new Set(arr)].forEach((element) => setContactModalHandlers(element));

  setContactModalHandlers("#modalContactUsABTest");
})();

$(".owl-carousel").each(function () {
  var $this = $(this);
  $this.one("inview", function () {
    jQuery(".owl-carousel").trigger("refresh.owl.carousel");

    $this.find(".owl-item.cloned img").each(function () {
      var getSrcAttr = $(this).attr("data-src");
      $(this).attr("src", getSrcAttr).removeClass("lazy");
    });
  });
});

jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, {
      passive: !ns.includes("noPreventDefault"),
    });
  },
};
jQuery.event.special.wheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("wheel", handle, { passive: true });
  },
};
jQuery.event.special.mousewheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("mousewheel", handle, { passive: true });
  },
};

//скрипт для формы Free access to EOSDA Crop Monitoring, для корректной передачи в ЗОХО
$(document).ready(function () {
  let radioContainer = $(".custom-value-for-radio-js");
  if (radioContainer.length) {
    let firstRadioOrganization = radioContainer.find(
      ".first label span.wpcf7-list-item-label"
    );
    let secondRadioMyself = radioContainer.find(
      ".last label span.wpcf7-list-item-label"
    );

    if (firstRadioOrganization.length && secondRadioMyself.length) {
      firstRadioOrganization.text("Представник компанії");
      secondRadioMyself.text("Індивідуальний користувач");
    }
  }
});
